import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51e4659b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=51e4659b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4659b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e4659b')) {
      api.createRecord('51e4659b', component.options)
    } else {
      api.reload('51e4659b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=51e4659b&scoped=true&", function () {
      api.rerender('51e4659b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/highRiskDataManagement/index.vue"
export default component.exports